
import type { EnergyBlockType } from "@/lib/energy";
import { ENERGY_THRESHOLDS } from "@/lib/energy";
import type { TimeSlot } from "./types";

/**
 * Filters available time slots based on energy preference
 */
export function filterAvailableSlots(
  slots: TimeSlot[],
  options: { energyPreference?: EnergyBlockType }
): TimeSlot[] {
  const { energyPreference } = options;
  
  if (!energyPreference || 
      energyPreference === 'ignore' || 
      energyPreference === 'any' || 
      energyPreference.toLowerCase() === 'any') {
    return slots;
  }
  
  return slots.filter(slot => {
    // Use the same centralized threshold values
    if (energyPreference === 'power' && (slot.energyLevel || 0) >= ENERGY_THRESHOLDS.POWER) {
      return true;
    }
    if (energyPreference === 'focus' && (slot.energyLevel || 0) >= ENERGY_THRESHOLDS.FOCUS) {
      return true;
    }
    if (energyPreference === 'drift') {
      const energy = slot.energyLevel || 0;
      return energy >= ENERGY_THRESHOLDS.DRIFT && energy < ENERGY_THRESHOLDS.FOCUS;
    }
    return false;
  });
}
